<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M15.15 4.562a.924.924 0 011.7 0l2.908 6.382c.137.301.411.51.727.553l6.695.924c.786.109 1.1 1.122.526 1.693l-4.898 4.87c-.231.23-.336.566-.278.894l1.23 6.954c.144.816-.68 1.442-1.376 1.046l-5.935-3.373a.904.904 0 00-.898 0l-5.935 3.373c-.697.396-1.52-.23-1.376-1.046l1.23-6.954a1.015 1.015 0 00-.278-.895l-4.898-4.869c-.574-.57-.26-1.584.526-1.693l6.695-.924a.946.946 0 00.727-.553l2.908-6.382z"/></svg>
</template>

<script>
export default {
  name: 'symbolsStarFilled'
}
</script>
